<template>
  <div class="view">
    <h1>会社概要</h1>
    <div class="information">
      <Information />
    </div>
  </div>
</template>

<script>
import Information from "../components/Information";
import { setMeta } from "../lib/meta";

export default {
  mounted() {
    setMeta({
      subtitle: "会社概要",
      description: "マルキ鈴菊商店の会社概要です。",
      path: this.$route.path,
      image: undefined
    });
  },
  components: {
    Information
  }
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
  font-size: 1.5em;
  padding: 1em 0;
}
.pdf {
  text-align: right;
  padding-right: 1em;
}
.information {
  margin: 0 1em 1em 1em;
  padding: 0.5em;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba($color: #000, $alpha: 0.6);
}
</style>
